





























































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ResponsiveImage from '../ResponsiveImage.vue';
import { Product, ProductListItem, AltField } from '@/models/Product';

@Component({
    components: {
        ResponsiveImage
    }
})
export default class ProductList extends Vue {
    @Prop()
    protected products!: ProductListItem[];

    @Prop({ default: false })
    protected hideColorList!: Boolean;
    
    @Prop()
    protected productNameTag!: string;

    private showAltFieldsOnly: Boolean = false;

    constructor() {
        super();
        
    }

    get productsList(): Array<ProductListItem> {
        var products = typeof this.products === 'string' ? JSON.parse(this.products) : this.products;

        if (products != null && products.length > 0 && products.some((e:ProductListItem) => e.AltFields != null && e.AltFields.length > 0))
        {
            this.showAltFieldsOnly = true;
        }
        return products;
    }
}
